export default __webpack_public_path__ + "static/media/certificate-badge-math.b76c5d58.svg";